import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "twoPeople"
const TwoPeopleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M9 14.25C10.108 14.25 11.052 14.381 11.857 14.604L11.875 14.61C16.5 15.903 16.5 20.25 16.5 20.25H1.5S1.5 14.25 9 14.25M9 15.75C5.73 15.75 4.354 17.014 3.71 18.045 3.562 18.28 3.445 18.52 3.352 18.75H14.648C14.555 18.52 14.438 18.281 14.29 18.045 13.646 17.015 12.27 15.75 9 15.75"
            clipRule="evenodd"
          />
          <path d="M15 12.75C22.5 12.75 22.5 18.75 22.5 18.75H17.794C17.686 18.31 17.52 17.793 17.265 17.25H20.648C20.555 17.02 20.438 16.781 20.29 16.545 19.646 15.515 18.27 14.25 15 14.25Q14.844 14.251 14.692 14.255C14.045 13.825 13.284 13.46 12.392 13.198Q12.549 13.09 12.7 12.97C13.375 12.83 14.138 12.75 15 12.75" />
          <path
            fillRule="evenodd"
            d="M9 3.75C9.965 3.75 10.858 4.055 11.591 4.573L11.624 4.596C12.76 5.413 13.5 6.744 13.5 8.25 13.5 10.735 11.485 12.75 9 12.75S4.5 10.735 4.5 8.25 6.515 3.75 9 3.75M9 5.25C7.343 5.25 6 6.593 6 8.25S7.343 11.25 9 11.25 12 9.907 12 8.25 10.657 5.25 9 5.25"
            clipRule="evenodd"
          />
          <path d="M15 2.25C17.485 2.25 19.5 4.265 19.5 6.75S17.485 11.25 15 11.25Q14.607 11.248 14.232 11.182C14.484 10.734 14.682 10.252 14.812 9.742Q14.905 9.75 15 9.75C16.657 9.75 18 8.407 18 6.75S16.657 3.75 15 3.75C14.422 3.75 13.882 3.914 13.424 4.198 13.074 3.816 12.675 3.48 12.238 3.2 13.001 2.606 13.958 2.25 15 2.25" />
        </svg>
      }
    </span>
  )
}
export default TwoPeopleIcon
